import * as CryptoJS from 'crypto-js'
import config from '../configs'

export function encrypt<T>(data: T): string {
  const cipher = CryptoJS.AES.encrypt(JSON.stringify(data), config.aes_secret_key)
  return cipher.toString()
}

export function decrypt<T>(cipher: string): T {
  try {
    const decrypted = CryptoJS.AES.decrypt(cipher, config.aes_secret_key)
    const plaintext = decrypted.toString(CryptoJS.enc.Utf8)

    if (!plaintext) {
      return {} as T
    }

    return JSON.parse(plaintext)
  } catch (error: any) {
    console.log('🚀 ~ file: aes.ts ~ decrypt ~ error:', error, cipher)
    return {} as T
  }
}
